import type { SVGProps } from 'react';

const SvgTicket = (props: SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M22.7497 14.5837C22.7497 12.9737 24.0563 11.667 25.6663 11.667V10.5003C25.6663 5.83366 24.4997 4.66699 19.833 4.66699H8.16634C3.49967 4.66699 2.33301 5.83366 2.33301 10.5003V11.0837C3.94301 11.0837 5.24967 12.3903 5.24967 14.0003C5.24967 15.6103 3.94301 16.917 2.33301 16.917V17.5003C2.33301 22.167 3.49967 23.3337 8.16634 23.3337H19.833C24.4997 23.3337 25.6663 22.167 25.6663 17.5003C24.0563 17.5003 22.7497 16.1937 22.7497 14.5837Z"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.667 4.66699L11.667 23.3337"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeDasharray="5 5"
    />
  </svg>
);
export default SvgTicket;
